import {$controller} from "rapid/index";
import {clone, delay} from "lodash";

import {MediaDownloadController} from "./media-download/media-download";
import MediaDownloadTemplate from "./media-download/media-download.html";

import {DownloadDialogController} from "./download-dialog/download-dialog";
import DownloadDialogTemplate from "./download-dialog/download-dialog.html";

const dependencies = ["$Forms", "$companies", "$Booth", "$service", "$Deployment", "$Company"];

class MediaController extends $controller {

    constructor($injector, $stateParams, $scope, $element, $q, $timeout, $auth) {
        "ngInject";
        super($injector, dependencies);
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$element = $element;
        this.$auth = $auth;
        this.$scope.loading = true;
        this.$scope.query = {page: 1, search: ""};
        this.$scope.filter = {};
        this.$scope.deployments = [];
        this.$scope.pageCount = 0;
        this.$scope.canAddMore = true;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$scope.logOrder = () => {
            this.$scope.query.ordering = this.$scope.query.order.replace("_", "");
            this.query(true);
        };
        this.logisticsType = {
            "by_upreach": "By UpReach",
            "by_client": "By Client"
        };

        this.searchByKeyPress = (event) => {
            const keyName = event.key;
            const letters = "abcdefghijklmnopqrstuvwxyz";
            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
                this.$scope.$apply(() => {
                    this.$scope.filter.show = true;
                    if (!this.$scope.query.search) {
                        this.$scope.query.search = keyName;
                    }
                });
                delay(() => {
                    document.getElementById("search-field").focus();
                }, 100);
            }
        };

    }

    $onInit() {
        this.$scope.filter.show = false;
        this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
        document.addEventListener("keypress", this.searchByKeyPress);
    }

    $onDestroy() {
        document.removeEventListener("keypress", this.searchByKeyPress);
    }

    query(isNew) {
        var deployments = this.$Deployment.query(this.$scope.query);

        Promise.all([deployments.$promise]).then(() => {
            this.$scope.query.page = deployments._meta.page || 1;
            this.$scope.loading = false;

            isNew ? this.$scope.deployments = deployments : this.$scope.deployments.push(...deployments);
            this.$scope.pageCount = deployments._meta.page_count;
            this.$scope.canAddMore = this.$scope.query.page !== this.$scope.pageCount;

            this.$scope.$apply();
        });
    }

    addMoreItems() {
        this.$scope.query.page++;
        this.query();
    }

    onQueryFilterChange() {
        this.$scope.query.page = 1;
        const newValue = clone(this.$scope.query.search);
        this.$scope.loading = true;
        this.searhDelayTimeout = setTimeout(() => {
            const prewValue = clone(this.$scope.query.search);
            if (prewValue === newValue) {
                clearTimeout(this.searhDelayTimeout);
                this.query(true);

            }
        }, 500);
    }

    removeFilter () {
        this.$scope.filter.show = false;
        this.$scope.query.search = "";
    }

    showFilter() {
        this.$scope.filter.show = true;
        delay(() => {
            document.getElementById("search-field").focus();
        }, 100);
    }
    downloadDialog(id, rules) {
        let parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Create new configuration",
            controller: DownloadDialogController,
            template: DownloadDialogTemplate,
            targetEvent: event,
            locals: {
                callback: (obj) => {
                    this.$auth.$http({
                        url: `/api/live-gallery-zip/${obj.timeRange}`,
                        method: "PUT",
                        data: obj.data
                    }).then((resp) => {
                        if (resp.data && resp.data.zip_url) {
                            this.createZip(resp.data.zip_url);
                        } else {
                            this.$mdToast.show(
                                this.$mdToast.simple().position("bottom right").hideDelay(5000)
                                    .textContent(`This deployment has no photos!`)
                            );
                        }
                    }).catch((e) => {
                        console.log(e);
                    });
                    },
                id: id,
                minDate: this.minDate,
                maxDate: this.maxDate,
                rules: rules
            }
        });
    }

    getListOfOptions(id, deployment) {
        this.minDate = deployment.deployment_start ? moment(deployment.deployment_start)._d : null;
        this.maxDate = deployment.deployment_end ? moment(deployment.deployment_end)._d : null;
        let date = "";
        if (this.minDate && this.maxDate) {
            date = `?start_date=${moment(this.minDate).utc().format("YYYY-MM-DD HH:mm:SS")}&end_date=${moment(this.maxDate).utc().format("YYYY-MM-DD HH:mm:SS")}`;
        }
        this.$auth.$http({
            url: `/api/live-gallery-zip/${date}`,
            method: "PATCH",
            data: {
                deployment: id,
                outputTypes: {
                    printing: true,
                    sharing: true,
                    original: true
                },
                captureModes: {
                    photo: true,
                    gif: true,
                    boomerang: true,
                    video: true
                }
            }
        }).then((resp) => {
            this.downloadDialog(id, resp.data);
        }).catch((e) => {
            console.log(e);
        });
    }

    createZip(zipUrl) {
        let dialog = {
            title: "Download media",
            controller: MediaDownloadController,
            template: MediaDownloadTemplate,
            targetEvent: event,
            onRemoving: () => {
                clearInterval(interval);
            }
        };
        this.created = false;
        let interval = null;
        const MAX_TRIES = 60; // *5 sec

        this.$mdDialog.show(dialog);

         let tryDownload = () => {
            this.downloadZip(zipUrl).then((resp)=> {
                this.$mdDialog.hide(dialog);
                this.created = true;
                window.location.assign(resp.data.file);
            }).catch((e) => {
                if (e.status === 510) {
                    this.created = false;
                } else {
                    this.created = true;
                }
            });
         };
         let ping = 0;
         interval = setInterval(() => {
             if (this.created || ping >= MAX_TRIES) {
                 clearInterval(interval);
                 if (ping >= MAX_TRIES) {
                     this.$mdToast.show(
                         this.$mdToast.simple().position("bottom right").hideDelay(5000)
                             .textContent(`Download time turned out!`)
                     );
                     this.$mdDialog.hide(dialog);
                 }
             } else {
                 ping ++;
                 tryDownload();
             }
         }, 5000);
    }

    downloadZip(url) {
        return this.$auth.$http({
            url: url,
            method: "GET"
        }).then((resp) => {
            return resp;
        }).catch((e) => {
            return this.$q.reject(e);
        });
    }

    onSearchBlur() {
        if (!this.$scope.query.search) {
            this.$scope.filter.show = false;
        }
    }

    isClient() {
        return this.$auth.isRole("Client") || this.$auth.isRole("Sub-User");
    }
}

export default MediaController;



// WEBPACK FOOTER //
// ./sources/components/media/media.controller.js